import { orderLinePayload } from "./cuttingLine";
import { IVmcLineInput, VmcSource } from "../types/vmcOrder";

// Helpers of the VMC module's kinds of pieces. A line takes cut pieces (1, cutting ready) or turned pieces (2, turning
// ready), so its key carries the kind too ("12:3:2", "12:0:1" for an item without sizes), and an order may have the
// same item and size once of each kind. Keep the key in step with VmcLines::key on the backend. The rest comes from
// cuttingLine.ts and materialLine.ts, like the turning module's.

export const vmcOptionKey = (
  itemId: number,
  sizeId: number | null | undefined,
  source: VmcSource
) => `${itemId}:${sizeId || 0}:${source}`;

export const vmcLineKey = (line: {
  item_id: number;
  size_id: number | null;
  source: VmcSource;
}) => vmcOptionKey(line.item_id, line.size_id, line.source);

// A picker card is one item of one kind.
export const vmcCardKey = (itemId: number, source: VmcSource) =>
  `${itemId}:${source}`;

// The kind as the screens name it (user, 2026-11-01): the picker card's ready line, the rows' chip and the detail pages.
export const sourceLabel = (source: VmcSource | undefined) =>
  source === 2 ? "ટર્નિંગ તૈયાર" : "કટીંગ તૈયાર";

// The order's lines as the API takes them: a cutting order line's fields and the kind. The shared payload keeps only
// the fields it knows, so the kind is added back here.
export const vmcOrderLinePayload = (
  lines: IVmcLineInput[],
  withRates: boolean
) =>
  orderLinePayload(lines, withRates).map((payload, index) => ({
    ...payload,
    source: lines[index].source,
  }));
